import controller_0 from '@symfony/ux-swup/dist/controller.js';
export default {
  'symfony--ux-swup--swup': controller_0,
};